import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { FONTS } from '@/styles';
import { Label } from '@/components/label';

const AVAILABILITY_LABEL_MAX_WIDTH = 200;

interface Props {
  text: string;
}

export const LeadTimeLabel: React.FC<Props> = ({ text }) => {
  const [styles, theme] = useStyles();
  return (
    <Label
      backgroundColor={theme.sk.color.bg.success}
      labelStyle={styles.label}
      text={text}
      textStyle={styles.text}
    />
  );
};

const useStyles = createStyles((theme) => ({
  label: {
    borderRadius: 4,
    maxWidth: AVAILABILITY_LABEL_MAX_WIDTH,
  },
  text: {
    ...FONTS.primarySemiBold,
    color: theme.sk.color.text.success,
    textTransform: 'none',
  },
}));
